// lazyload Script
// Documentation: https://docs.google.com/document/d/1CpbtkAN8kR93hARhitE8rW4zAJ2pQbHo6JwJIBUzrWM/

// OBSERVERS //
// .lazy (add to observer)
// .observe (Adds/remove .observing when in/out of viewport)

// .lazy MODIFIERS //
// .responsive-video (For video: loads responsive video, play when in viewport, pause when not in viewport)
// .lazy-focus (Control content to load only when in viewport)
// .lazy-fade (For image: adds fade in)
// .lazy-container
// -  all img[data-src] in .lazy-container will be loaded
// 1. Do not need .lazy
// 2. Can have modifiers

// .observe modifiers //
// .video-from-start
// .video-once


// INITIATE LAZYLOAD
var thresholdVertical = '500px',
    observerGeneral = observerFocus = '';

// GENERAL - OBSERVE WITH THRESHOLD
var configGeneral = {
    rootMargin: thresholdVertical + ' 0px',
    threshold: 0.01
};

// CONSISTENT OBSERVER - OBSERVE IN VIEWPORT
var configFocus = {
    threshold: 0.01
};

// GENERAL OBSERVER EVENT
function onIntersectionGeneral(entries) {
    entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
            observerGeneral.unobserve(entry.target);
            preloadImage(entry.target);
        }
    });
}

// FOCUS OBSERVER EVENT
function onIntersectionFocus(entries) {
    entries.forEach(entry => {
        if (entry?.intersectionRatio > 0.01) {
            if (entry?.target?.classList?.contains('observe')) {
                entry?.target?.classList.add('observing');

                if (entry?.target?.nodeName == 'VIDEO') {
                    if (!entry.target.matches('.video-once.ended')) {
                        entry.target?.play()?.then(_ => { /* Auto-play started */ })?.catch(error => { /* Auto-play prevented */ });
                    }
                }
            } else {
                observerFocus.unobserve(entry?.target);
                if (entry?.target?.complete) {
                    entry?.target?.classList.add('focused');
                } else {
                    entry?.target?.addEventListener('load', function() { this.classList.add('focused'); });
                }
            }
        } else {
            entry?.target?.classList?.remove('observing');

            if (entry?.target?.nodeName == 'VIDEO') {
                const isPlaying = entry?.target?.currentTime > 0 && !entry?.target?.paused && !entry?.target?.ended && entry?.target?.readyState > entry?.target?.HAVE_CURRENT_DATA;
                if (isPlaying) entry?.target?.pause();
                if (entry?.target?.classList?.contains('video-from-start') && !entry?.target?.classList?.contains('video-once')) {
                    entry.target.currentTime = 0;
                }
            }
        }
    });
}

// preloadImage EVENT
function preloadImage(i) {
    loadImg = function(img) {
        var obj = new Image();
        obj.onload = function() {
            img.setAttribute('src', obj.src);
            img.classList.add('lazy-loaded');
        }
        obj.src = img.getAttribute('data-src');
    }

    if ( i.classList.contains('lazy-container') ) {
        const images = i.querySelectorAll('img[data-src]');
        Array.from(images).forEach(image => {
            loadImg(image);
        });
    } else if ( i.classList.contains('responsive-video') ) {
        responsiveVideoSwitch(i);
    } else {
        if ( !i.classList.contains('lazy-bg') ) {
            if ( i.hasAttribute('data-srcset') ) { i.setAttribute('srcset',i.getAttribute('data-srcset')); }
            if ( i.hasAttribute('data-src') ) {
                loadImg(i);
            }
        }
    }

    if ( i.nodeName != 'IMG' || i.hasAttribute('data-srcset') ) {
        i.classList.add('lazy-loaded');
    }
}

// SET SIZES FOR .responsive-image AND FIRE EVENT ON WINDOW RESIZE
var responsiveImage = {};
responsiveImage = function(element) {
    if (element != null) {
        document.querySelectorAll(element).forEach(function(v, i) {
            v.getAttribute('data-sizes', Math.ceil(v.parentElement.offsetWidth)+'px');
        });
    } else {
        document.querySelectorAll('.responsive-image').forEach(function(v, i) {
            v.getAttribute('data-sizes', Math.ceil(v.parentElement.offsetWidth)+'px');
        });
    }
}

// SET RESPONSIVE VIDEO
function responsiveVideoSwitch(i) {
    var source = "";

    if ( window.innerWidth >= 992 ) {
        source += '<source src="'+i.getAttribute('data-webm-large')+'">';
        source += '<source src="'+i.getAttribute('data-mp4-large')+'">';
        i.classList.remove('loaded-small', 'playing', 'ended');
        i.classList.add('loaded-large');
    } else {
        source += '<source src="'+i.getAttribute('data-webm-small')+'">';
        source += '<source src="'+i.getAttribute('data-mp4-small')+'">';
        i.classList.remove('loaded-large', 'playing', 'ended');
        i.classList.add('loaded-small');
    }
    // img source deprecated
    // source += '<img src="'+i.getAttribute('data-img')+'">';

    if ( i.parentElement.classList.contains('focus-video-obj') ) { i.parentElement.classList.remove('playing', 'ended'); } else { i.classList.remove('playing', 'ended'); }
    i.innerHTML = '';
    i.insertAdjacentHTML('beforeend', source);
    i.load();

    var _this = i;
    if (i.classList.contains('observing')) {
        _this.play()?.then(_ => { /* Auto-play started */ })?.catch(error => { /* Auto-play prevented */ });
    }
}

// INITIALIZE LAZYLOAD EVENT
function initLazyload() {
    if (observerGeneral != '' || observerFocus != '') {
        observerGeneral.disconnect();
        observerFocus.disconnect();
    }

    var imgGeneral = document.querySelectorAll('.lazy'),
        imgFocus = document.querySelectorAll('.lazy.lazy-focus'),
        observeConsistent = document.querySelectorAll('.observe');

    // FALLBACK IF IntersectionObserve IS MISSING
    // OTHERWISE START OBSERVER
    if (!('IntersectionObserver' in window) || websiteMode == 'e2e-testing') {
        Array.from(imgGeneral).forEach(obj => preloadImage(obj));
        Array.from(imgFocus).forEach(obj => preloadImage(obj));
    } else {
        observerGeneral = new IntersectionObserver(onIntersectionGeneral, configGeneral);
        observerFocus = new IntersectionObserver(onIntersectionFocus, configFocus);

        imgGeneral.forEach(obj => {
            if (!obj.classList.contains('lazy-loaded')) { observerGeneral.observe(obj); }
        });

        imgFocus.forEach(obj => {
            if (!obj.classList.contains('lazy-loaded')) { observerFocus.observe(obj); }
        });

        observeConsistent.forEach(obj => {
            observerFocus.observe(obj);
        });
    }

    // OBSERVE VIDEO
    document.querySelectorAll('video.observe:not(.focus-play)').forEach(function(v, i){
        var _this = v;
        v.oncanplay = _this.classList.add('canplay');
        v.onplay = function() { _this.classList.add('playing'); _this.classList.remove('paused', 'ended'); }
        v.onpause = function() { _this.classList.add('paused'); _this.classList.remove('playing', 'ended'); }
        v.onended = function() { _this.classList.add('ended'); _this.classList.remove('playing', 'paused'); };
    });
}

initLazyload();
responsiveImage?.();
window.onresize = function() {
    responsiveImage?.();

    if ( window.innerWidth >= 992 ) {
        document.querySelectorAll('.responsive-video').forEach(function(v, i) {
            if ( !v.classList.contains('loaded-large') ) { responsiveVideoSwitch(v); }
        });
    } else {
        document.querySelectorAll('.responsive-video').forEach(function(v, i) {
            if ( !v.classList.contains('loaded-small') ) { responsiveVideoSwitch(v); }
        });
    }
}
window.lazyload = [];